import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://lokeswaran.in';

// Per-route title + canonical.
// Because this is a client-side-rendered SPA served from a single static
// index.html, the canonical <link> and <title> are updated here on navigation
// so each indexable route has exactly one correct canonical URL.
const PAGE_META = {
  '/': {
    title: 'Lokeswaran | React Native & React Developer | Chennai, India',
    canonical: `${BASE_URL}/`,
  },
  '/about': {
    title: 'About | Lokeswaran | React Native & React Developer',
    canonical: `${BASE_URL}/about`,
  },
  '/projects': {
    title: 'Projects | Lokeswaran | React Native & React Developer',
    canonical: `${BASE_URL}/projects`,
  },
  '/Skills': {
    title: 'Skills | Lokeswaran | React Native & React Developer',
    canonical: `${BASE_URL}/Skills`,
  },
  '/contact': {
    title: 'Contact | Lokeswaran | React Native & React Developer',
    canonical: `${BASE_URL}/contact`,
  },
};

function RouteMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = PAGE_META[pathname] || PAGE_META['/'];

    if (meta.title) {
      document.title = meta.title;
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', meta.canonical);

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', meta.canonical);
    }

    // Scroll to top only on the homepage. On the section routes
    // (/about, /projects, /contact, /Skills) the Home page handles
    // scrolling to the matching section itself.
    if (pathname === '/') {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

export default RouteMeta;
